import { useRef } from "react";

export function useDebouncedFunction(fn = () => {}, delay = 500) {
  const timeoutRef = useRef(null);

  const debouncedFn = (...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      fn(...args);
    }, delay);
  };

  return debouncedFn;
}
